var exports = {
  "e": "x31de4314--671afa--spinner-container",
};

module.exports = exports;
